<template>
  <v-container fluid>
    <v-card class="elevation-2" max-width="640">
      <v-toolbar color="primary" dark flat>
        <v-icon class="mr-2">mdi-cog</v-icon>
        <v-toolbar-title>Configuración</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-6">
        <div class="text-subtitle-1 font-weight-medium mb-4">Datos personales</div>
        <v-form ref="form" v-model="valid">
          <v-row dense>
            <v-col cols="6"><v-text-field v-model="form.name" label="Nombre *" outlined dense :rules="[required]"></v-text-field></v-col>
            <v-col cols="6"><v-text-field v-model="form.lastname" label="Apellidos *" outlined dense :rules="[required]"></v-text-field></v-col>
          </v-row>
          <v-text-field v-model="form.username" label="Email *" outlined dense :rules="[required]"></v-text-field>
          <v-text-field v-model="form.phone" label="Teléfono" outlined dense></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!valid" :loading="saving" @click="save">
          <v-icon left>mdi-content-save</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import UserService from '@/services/UserService'
import { apiError } from '@/grupo'

export default {
  name: 'GrupoConfiguracion',

  data: () => ({
    valid: false,
    saving: false,
    form: { name: '', lastname: '', username: '', phone: '' }
  }),

  mounted () {
    const user = this.$store.getters.CURRENT_USER
    this.form = { name: user.name, lastname: user.lastname, username: user.email, phone: user.phone }
  },

  methods: {
    required: v => !!v || 'Obligatorio',

    async save () {
      this.saving = true
      try {
        // Ningún usuario puede cambiar sus propios roles ni permisos: solo se envían sus datos
        await UserService.put({ id: this.$store.getters.CURRENT_USER.id, ...this.form })
        await this.$store.dispatch('RELOAD_USER_DATA')
        this.$toast.success('Datos guardados')
      } catch (error) {
        this.$toast.error(apiError(error, 'No se pudieron guardar los datos'))
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
